export default __webpack_public_path__ + "static/media/1342.7ee5e4a0.png";